import { platform, PlatformType } from "./platform";

export function getClassName(
  base: string,
  os: PlatformType = platform()
): string {
  return `${base} ${base}--${os}`;
}
